'use client'
import { Log } from '../../lib/log'

export function DatadogProvider({ children }: { children: React.ReactNode }) {
    return <>{children}</>;
}